import { Component } from '@angular/core';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faPhone, faUser } from '@fortawesome/free-solid-svg-icons';

import { AuthComponent, LocalizeComponent } from '../../../shared/components';

@Component({
  selector: 'app-title',
  imports: [FontAwesomeModule, LocalizeComponent, AuthComponent],
  templateUrl: './title.component.html',
  styleUrl: './title.component.scss'
})
export class TitleComponent {

  //#region Font Awesome Icons
  /** Phone icon from Font Awesome */
  iconPhone = faPhone;

  /** User icon from Font Awesome */
  iconUser = faUser;
  //#endregion

}
